<template>
    <div class="checkbox">
        <input
            :id="uniqueId"
            ref="input"
            type="checkbox"
            :checked="value"
            :disabled="disabled"
            @change="handleInputChange"
        >

        <label
            class="checkbox__label"
            :for="uniqueId"
        >
            <b class="checkbox__checkmark">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11"
                    height="8"
                    viewBox="0 0 11 8"
                >
                    <path d="M3.49813683,8 L0.243843712,4.75457909 C-0.0812812375,4.43034053 -0.0812812375,3.90464596 0.243843712,3.5804074 C0.56910139,3.25603647 1.09633478,3.25566981 1.42204578,3.57958802 L3.83026495,5.9745518 L9.57730299,0.243181961 C9.902432,-0.0810606538 10.4295703,-0.0810606538 10.7546993,0.243181961 C11.0822367,0.572135678 11.0813016,1.09995452 10.7546846,1.42568111 L4.16239308,8" />
                </svg>
            </b>
            <b v-html="label" />
        </label>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        uniqueId() {
            return $_.uniqueId('checkbox_')
        },
    },

    methods: {
        handleInputChange() {
            this.$emit('input', this.$refs.input.checked)
        },
    },
}
</script>
